export const version = '2.13.5';
//# sourceMappingURL=version.js.map